import React from 'react'

const Contact = () => {
    return (
        <section id="contact" className="pane contact-pane">
            <div>
                <h2>Let's build something.</h2>
                <p>Open to new roles and collaborations &mdash; reach out any time.</p>
            </div>
            <a className="btn-fill" href="mailto:cesar.decasasgarcia@gmail.com">cesar.decasasgarcia@gmail.com</a>
        </section>
    )
}

export default Contact
